/**
 * Do not edit directly — generated by `pnpm build-tokens`.
 */

import { theme as AntdTheme, type ThemeConfig } from 'antd';

const { darkAlgorithm, defaultAlgorithm } = AntdTheme;

export const antdThemes: Record<"light" | "dark", ThemeConfig> = {
  light: {
    algorithm: defaultAlgorithm,
    token: {
      colorBgContainerDisabled: "#f3f5f7",
      colorInfoBg: "#ebeefb",
      colorPrimary: "#d2f740",
      colorText: "#0c0c0b",
      colorLink: "#0c0c0b",
      colorLinkHover: "#0c0c0b",
      colorLinkActive: "#0c0c0b",
      colorTextLightSolid: "#0c0c0b",
      colorPrimaryHover: "#b3d049",
      colorBgMask: "rgba(21, 21, 20, 0.4)",
      fontFamily: "'ProximaNova', sans-serif",
      borderRadius: 4,
      fontSize: 14,
      colorTextBase: "#0c0c0b",
      colorBgBase: "#fafafa",
      borderRadiusXS: 2,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      sizeUnit: 4,
      sizeStep: 4,
      fontFamilyCode: "Roboto Mono",
      lineWidth: 1,
      colorPrimaryActive: "#d2f740",
      colorBorder: "#e6e6e6",
      colorBorderSecondary: "#e6e6e6",
      colorTextPlaceholder: "#767676",
      colorTextDisabled: "#808080",
      colorTextDescription: "#4d4d4d",
      colorTextHeading: "#0c0c0b",
      colorBgContainer: "#ffffff",
      colorBgLayout: "#fafafa",
      boxShadow: "0px 0px 6px 0px rgba(12, 12, 11, 0.08)",
      boxShadowSecondary: "0px 2px 16px 0px rgba(12, 12, 11, 0.04)",
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSizeXL: 20,
      fontSizeHeading1: 28,
      fontSizeHeading2: 24,
      fontSizeHeading3: 20,
      fontSizeHeading4: 16,
      fontSizeHeading5: 14,
      fontWeightStrong: 700
    },
    components: {
      Collapse: {
        colorBgContainer: "#ffffff",
        colorFillAlter: "#ffffff",
        colorTextHeading: "#0c0c0b",
        paddingSM: 24,
        padding: 24
      },
      Menu: {
        itemSelectedBg: "#d2f740",
        colorTextDisabled: "#4d4d4d",
        itemMarginInline: 0,
        itemBorderRadius: 0
      },
      Table: {
        colorFillAlter: "#ffffff",
        colorTextHeading: "#0c0c0b",
        colorBgContainer: "#ffffff",
        fontWeightStrong: 400,
        colorPrimary: "#b3d049"
      },
      Tabs: {
        cardBg: "#151514",
        colorBorder: "transparent"
      },
      Tooltip: {
        colorTextLightSolid: "#ffffff",
        colorBgSpotlight: "#283102"
      },
      Drawer: {
        colorBgElevated: "#f3f5f7"
      },
      DatePicker: {
        colorPrimary: "#396b00"
      },
      Input: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      InputNumber: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      Select: {
        colorPrimaryHover: "#396b00",
        colorTextPlaceholder: "#4d4d4d",
        controlHeight: 24,
        controlHeightSM: 24,
        fontSize: 12,
        controlItemBgActive: "#f3f5f7"
      },
      Radio: {
        colorPrimary: "#396b00",
        colorPrimaryHover: "#396b00",
        colorPrimaryActive: "#396b00"
      },
      Checkbox: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Pagination: {
        colorPrimary: "#b3d049",
        colorPrimaryHover: "#b3d049"
      },
      Steps: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Switch: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Spin: {
        colorPrimary: "#b3d049"
      },
      Card: {
        boxShadowTertiary: "none"
      },
      Button: {
        lineHeight: 1,
        controlOutlineWidth: 0
      },
      Dropdown: {
        fontSize: 12
      },
      Modal: {
        marginSM: 32,
        headerBg: "#ffffff",
        contentBg: "#ffffff",
        titleColor: "#0c0c0b",
        titleFontSize: 16,
        titleLineHeight: 1.375
      },
      Statistic: {
        titleFontSize: 16,
        contentFontSize: 24
      },
      Tag: {
        defaultBg: "#fafafa",
        defaultColor: "#4d4d4d"
      },
      List: {
        headerBg: "#ffffff",
        footerBg: "#ffffff",
        descriptionFontSize: 12
      },
      Descriptions: {
        labelBg: "#ffffff",
        extraColor: "#4d4d4d"
      },
      Divider: {
        colorSplit: "#bdeb0a"
      }
    }
  },
  dark: {
    algorithm: darkAlgorithm,
    token: {
      colorBgContainerDisabled: "#222423",
      colorInfoBg: "#050816",
      colorPrimary: "#d2f740",
      colorText: "#ffffff",
      colorLink: "#ffffff",
      colorLinkHover: "#ffffff",
      colorLinkActive: "#ffffff",
      colorTextLightSolid: "#ffffff",
      colorPrimaryHover: "#b3d049",
      colorBgMask: "rgba(21, 21, 20, 0.4)",
      fontFamily: "'ProximaNova', sans-serif",
      borderRadius: 4,
      fontSize: 14,
      colorTextBase: "#ffffff",
      colorBgBase: "#222423",
      borderRadiusXS: 2,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      sizeUnit: 4,
      sizeStep: 4,
      fontFamilyCode: "Roboto Mono",
      lineWidth: 1,
      colorPrimaryActive: "#d2f740",
      colorBorder: "#4d4d4d",
      colorBorderSecondary: "#4d4d4d",
      colorTextPlaceholder: "#808080",
      colorTextDisabled: "#808080",
      colorTextDescription: "#edf0f3",
      colorTextHeading: "#ffffff",
      colorBgContainer: "#151514",
      colorBgLayout: "#222423",
      boxShadow: "0px 0px 6px 0px rgba(12, 12, 11, 0.08)",
      boxShadowSecondary: "0px 2px 16px 0px rgba(12, 12, 11, 0.04)",
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSizeXL: 20,
      fontSizeHeading1: 28,
      fontSizeHeading2: 24,
      fontSizeHeading3: 20,
      fontSizeHeading4: 16,
      fontSizeHeading5: 14,
      fontWeightStrong: 700
    },
    components: {
      Collapse: {
        colorBgContainer: "#151514",
        colorFillAlter: "#151514",
        colorTextHeading: "#ffffff",
        paddingSM: 24,
        padding: 24
      },
      Menu: {
        itemSelectedBg: "#d2f740",
        colorTextDisabled: "#edf0f3",
        itemMarginInline: 0,
        itemBorderRadius: 0
      },
      Table: {
        colorFillAlter: "#151514",
        colorTextHeading: "#ffffff",
        colorBgContainer: "#151514",
        fontWeightStrong: 400,
        colorPrimary: "#b3d049"
      },
      Tabs: {
        cardBg: "#151514",
        colorBorder: "transparent"
      },
      Tooltip: {
        colorTextLightSolid: "#151514",
        colorBgSpotlight: "#283102"
      },
      Drawer: {
        colorBgElevated: "#222423"
      },
      DatePicker: {
        colorPrimary: "#396b00"
      },
      Input: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      InputNumber: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      Select: {
        colorPrimaryHover: "#396b00",
        colorTextPlaceholder: "#edf0f3",
        controlHeight: 24,
        controlHeightSM: 24,
        fontSize: 12,
        controlItemBgActive: "#222423"
      },
      Radio: {
        colorPrimary: "#396b00",
        colorPrimaryHover: "#396b00",
        colorPrimaryActive: "#396b00"
      },
      Checkbox: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Pagination: {
        colorPrimary: "#b3d049",
        colorPrimaryHover: "#b3d049"
      },
      Steps: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Switch: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Spin: {
        colorPrimary: "#b3d049"
      },
      Card: {
        boxShadowTertiary: "none"
      },
      Button: {
        lineHeight: 1,
        controlOutlineWidth: 0
      },
      Dropdown: {
        fontSize: 12
      },
      Modal: {
        marginSM: 32,
        headerBg: "#151514",
        contentBg: "#151514",
        titleColor: "#ffffff",
        titleFontSize: 16,
        titleLineHeight: 1.375
      },
      Statistic: {
        titleFontSize: 16,
        contentFontSize: 24
      },
      Tag: {
        defaultBg: "#222423",
        defaultColor: "#edf0f3"
      },
      List: {
        headerBg: "#151514",
        footerBg: "#151514",
        descriptionFontSize: 12
      },
      Descriptions: {
        labelBg: "#151514",
        extraColor: "#edf0f3"
      },
      Divider: {
        colorSplit: "#d2f740"
      }
    }
  }
};

export type AntdThemeMode = keyof typeof antdThemes;

export const getAntdTheme = (mode: AntdThemeMode): ThemeConfig => antdThemes[mode];

export default antdThemes;
